import React, { useEffect } from 'react'
import OrderDetailView from '../../../containers/Inventory/transfer/OrderDetaillView'
import { useDispatch, useSelector } from 'react-redux';
import { clearSpecification, clearSubOrdes, getSubOrdes, mmanageOrder } from '../../../actions/transferActions';
const OrderDetaill = ({ match, history }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getSubOrdes(match.params.id))
    }, [match.params.id,dispatch])
    const { pendingOrder } = useSelector(state => state.tranfers)
    const { specifications } = useSelector(state => state.tranfers)
    useEffect(() => {
        return () => {
            dispatch(clearSpecification())
            dispatch(clearSubOrdes())
        }
    }, [dispatch])
    const mmanageOrderFn = (status) => {
        // const status = pendingOrder[0].orderId.status;
        const specificationsArray = specifications.map(specification => {
            return {
                subOrderId: specification.subOrderId,
                batches: specification.batches.map(batch => batch._id)
            }
        })
        // console.log();

        dispatch(mmanageOrder({

            // console.log({
            orderId: pendingOrder[0].orderId._id,
            status: status,
            specifications: specificationsArray
            //     ,,,paymentStatus,reasonForRejection
        }, history))
    }
    const reject = (motive) => {
        // const status = pendingOrder[0].orderId.status;

        dispatch(mmanageOrder({
            reasonForRejection: motive,
            orderId: pendingOrder[0].orderId._id,

        }, history))
    }

    return <OrderDetailView order={pendingOrder && pendingOrder.length > 0 && pendingOrder[0].orderId} subOrders={pendingOrder} mmanageOrder={mmanageOrderFn} reject={reject} />
}
export default OrderDetaill
